import ComponentTitle from "../ComponentTitle";
import TechCard from "./TechCard";
import javaIcon from "../../../resources/tech-stacks/java-original.svg";
import csharpIcon from "../../../resources/tech-stacks/c-sharp.png";
import skillIcon from "../../../resources/tech-stacks/skill.png";
import javascriptIcon from "../../../resources/tech-stacks/javascript-original.svg";
import phpIcon from "../../../resources/tech-stacks/php.svg";
import tsIcon from "../../../resources/tech-stacks/Typescript.svg.png";
import netIcon from "../../../resources/tech-stacks/net.png";
import reactIcon from "../../../resources/tech-stacks/react.png";
import expressIcon from "../../../resources/tech-stacks/express.svg";
import {useEffect} from "react";
import Aos from "aos";

const techStacks = [
    {
        name: "java",
        iconUrl: javaIcon
    },
    {
        name: "C#",
        iconUrl: csharpIcon
    },
    {
        name: "PHP",
        iconUrl: phpIcon
    },
    {
        name: "JavaScript",
        iconUrl: javascriptIcon
    },
    {
        name: "Typescript",
        iconUrl: tsIcon
    }
]

const frameworkStacks = [
    {
        name: "React",
        iconUrl: reactIcon
    },
    {
        name: "net",
        iconUrl: netIcon
    },
    {
        name: "express",
        iconUrl: expressIcon
    }
]

const MyTechStack = ({programmingLanguages, frameworks, others}) => {

    useEffect(() => {
        Aos.init({
            duration: 2000
        });
    }, [])
    
    return(
        <section 
            data-aos="fade-up" 
            id={"techstack"} 
            className="py-20 bg-slate-50 dark:bg-slate-900 transition-colors duration-300 relative overflow-hidden"
        >
            {/* Subtle separator line top */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-slate-700 to-transparent"></div>
            
            <div className="container mx-auto px-6 lg:px-8">
                <ComponentTitle title={'Tech Stack'} subTitle={'Technologies I have been working with'} />
                
                <div className="mt-16 grid grid-cols-1  items-center">
                    {/* Tech cards section */}
                    <div className="space-y-8">
                        <TechCard title={'Programming Languages'} techStacks={programmingLanguages} />
                        <TechCard title={'Frameworks & Libraries'} techStacks={frameworks} />
                        <TechCard title={'Tools & Others'} techStacks={others} />
                    </div>
                    
                    {/* Illustration section */}
                    {/*<div className="flex justify-center xl:justify-end">*/}
                    {/*    <div className="relative group">*/}
                    {/*        <div className="absolute -inset-8 bg-gradient-to-r from-blue-400/20 to-indigo-400/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>*/}
                    {/*        <img */}
                    {/*            src={skillIcon} */}
                    {/*            alt="Technical skills illustration"*/}
                    {/*            className="relative z-10 w-full max-w-md transition-transform duration-500 group-hover:scale-105"*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </section>
    )
}
export default MyTechStack;
